import { lazy } from 'react';

import { PATHS } from '@/constants/page-paths';
import { RouteTypes } from '@/types/config-types';

export const publicRoutes: RouteTypes[] = [
  {
    routeKey: 'home',
    path: '/',
    name: 'Home',
    component: lazy(() => import('@/pages/Landing')),
  },
  {
    routeKey: 'showroom',
    path: '/showroom',
    name: 'Showroom',
    component: lazy(() => import('@/pages/twin-showroom/Showroom')),
  },
  {
    routeKey: 'chat',
    path: '/chat',
    name: 'Chat',
    component: lazy(() => import('@/pages/chat/Chat')),
  },
  {
    routeKey: 'chat',
    path: '/chat/:twinName',
    name: 'Chat',
    component: lazy(() => import('@/pages/chat/Chat')),
  },

  {
    routeKey: 'payment_status',
    path: '/payment',
    name: 'Payment Status',
    component: lazy(() => import('@/pages/payment/PaymentStatus')),
  },
  {
    routeKey: 'verify',
    path: '/verify',
    name: 'Verify',
    component: lazy(() => import('@/pages/others/Verify')),
  },
  {
    routeKey: 'twin_redirect',
    path: '/t/:twinName',
    name: 'Twin Redirect',
    component: lazy(() => import('@/pages/others/TwinRedirect')),
  },
  {
    routeKey: 'twin_demo',
    path: '/twin-demo/:demoToken',
    name: 'Twin Demo',
    component: lazy(() => import('@/pages/others/TwinDemo')),
  },
  {
    routeKey: 'help_and_feedback',
    path: '/feedback',
    name: 'Help & Feedback',
    component: lazy(() => import('@/pages/feedback/Feedback')),
  },
  {
    routeKey: 'watch_ai_video',
    path: '/watch/:videoId',
    name: 'Watch AI Video',
    component: lazy(() => import('@/pages/twin-studio/TwinVideoPlayback')),
  },
  {
    routeKey: 'get_twin',
    path: '/get-twin',
    name: 'Get your Twin',
    component: lazy(() => import('@/pages/my-twin/twin-landing')),
  },
  {
    routeKey: 'studio_landing',
    path: '/get-twin-studio',
    name: 'Get Started with Twin Studio',
    component: lazy(
      () => import('@/pages/twin-studio/studio-landing/StudioLanding')
    ),
  },
  {
    routeKey: 'maintenance',
    path: '/maintenance',
    name: 'Maintenance',
    component: lazy(
      () => import('@/components/shared/maintenance/MaintenancePage')
    ),
  },
  {
    path: PATHS.SSO_SIGN_IN,
    name: 'SSO Sign In',
    routeKey: 'sso_sign_in',
    component: lazy(() => import('@/pages/others/SSOLogin')),
  },
];
export const publicRouteNames = publicRoutes.map((route) => route.name);
export const publicRoutePaths = publicRoutes.map((route) => route.path);
